import { AbstractControl, Validators } from '@angular/forms';
import { SfTextAreaFormField } from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';

export class MaxLengthCounterField<T = any> extends SfTextAreaFormField<T> {
  constructor(field: IFormField<T>, private _maxLength: number) {
    super({
      ...field,
      validators: [
        ...(field.validators || []),
        Validators.maxLength(_maxLength),
      ],
    });
    this.errorMessageMap.set('maxlength', (ctrlError) => this.hint);
  }

  override get hint() {
    let valLength =
      (this.controlRef as AbstractControl<string | undefined>)?.value?.length ||
      0;
    if (!valLength) return '';
    let spareChars = this._maxLength - valLength;
    return spareChars.toString();
  }
}
